import * as React from "react";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useMentionRef } from "../../hooks/applicationHooks/useMentionRef";

import { nameof } from "../../utils";
import { ReferentialItemDto } from "../../api";
import { useCommonHooks } from "../../hooks";

export interface MentionSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
  onlyActive?: boolean;
}

export const MentionSelect: React.FunctionComponent<MentionSelectProps> = ({
  name,
  onlyActive = true,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { cadres, cadresLoading } = useMentionRef(onlyActive);

  return (
    <FGSelectInput
      label={t("Mention")}
      name={name}
      items={cadres}
      loading={cadresLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default MentionSelect;
